import { NgModule } from '@angular/core';
import { AgmCoreModule } from '@agm/core';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './components/app.component';
import { HomeComponent } from './components/home/home.component';
import { AgencyManagementComponent } from './components/solutions/agency-management.component';
import { CrmComponent } from './components/features/crm.component';
import { NewsroomComponent } from './components/newsroom/newsroom.component';
import { AboutUsComponent } from './components/company/about-us.component';
import { OurOfficesComponent } from './components/contact/our-offices.component';
import { DeveloperManagementComponent } from './components/solutions/developer-management.component';
import { StrataManagementComponent } from './components/solutions/strata-management.component';
import { RentalManagementComponent } from './components/solutions/rental-management.component';
import { TradeAssociationManagementComponent } from './components/solutions/trade-association.component';
import { Property2MatchComponent } from './components/solutions/property2match.component';
import { GlobalREComponent } from './components/solutions/global-re.component';
import { MoreSolutionsComponent } from './components/solutions/more-solutions.component';
import { EMarketingComponent } from './components/features/emarketing.component';
import { ECommerceComponent } from './components/features/ecommerce.component';
import { TransactionManagementComponent } from './components/features/transaction-management.component';
import { FinancialToolsComponent } from './components/features/financial-tools.component';
import { CmsComponent } from './components/features/cms.component';
import { PartnerProgramComponent } from './components/company/partner-program.component';
import { CareersComponent } from './components/company/careers.component';
import { BecomePartnerComponent } from './components/contact/become-partner.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppMaterialModule } from './controls/app-material.control';
import { TranslateLanguageLoader, AppTranslationService } from './services/core/app-translation.service';
import { MatNativeDateModule } from '@angular/material';
import { ConfigurationService } from './services/core/configuration.service';
import { ContactService } from './services/contact.service';
import { ContactEndpoint } from './services/contact-endpoint.service';
import { LocalStoreManager } from './services/core/local-store-manager.service';
import { EndpointFactory } from './services/core/endpoint-factory.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AgencyManagementComponent,
    DeveloperManagementComponent,
    StrataManagementComponent,
    RentalManagementComponent,
    TradeAssociationManagementComponent,
    Property2MatchComponent,
    GlobalREComponent,
    MoreSolutionsComponent,
    CrmComponent,
    EMarketingComponent,
    ECommerceComponent,
    TransactionManagementComponent,
    FinancialToolsComponent,
    CmsComponent,
    NewsroomComponent,
    PartnerProgramComponent,
    CareersComponent,
    AboutUsComponent,
    OurOfficesComponent,
    BecomePartnerComponent    
  ],
  imports: [
    FormsModule,      
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLanguageLoader
      }
    }),
    BrowserAnimationsModule,
    MatNativeDateModule,
    AppMaterialModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA5euMDQHyvEF5ldCuk4SycOoUyVxTxELs'
    }),
  ],
  providers: [
    ConfigurationService,
    AppTranslationService,
    ContactService,
    ContactEndpoint,
    LocalStoreManager,
    EndpointFactory,
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
